import Modal from '../../BaseComponents/Modal';
import './ClinicModal.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import 'react-loqate/dist/index.css';
type TypeName = {
  isOpen: boolean;
  onClose: () => void;
};



const ClinicModalView: React.FC<TypeName> = ({ isOpen, onClose }) => {
  
  const { clinicDataToView } = useSelector(
    (state: RootState) => state.clinics
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={'View Clinic'}
      width={'520px'}
    >
      <div className='main-info-container'>
          <h3 className='block-title'>Main Info</h3>
          <div className='info-item' >
            <label className='info-label' >Clinic Name</label>
            <div className='info-value'>{clinicDataToView?.title}</div>
          </div>
          <div className='info-item'>
            <label className='info-label'>Address</label>
            <div className='info-value'>{clinicDataToView?.address}</div>
          </div>
          <div className='info-item'>
            <label className='info-label'>Google Maps URL</label>
            <div className='info-value'>{clinicDataToView?.maps_link}</div>
          </div>
          <div className='info-item'>
            <label className='info-label'>Description</label>
            <div className='info-value'>{clinicDataToView?.description}</div>
          </div>
        </div>
        <div className='contact-info-container'>
          <h3 className='block-title'>Contact info</h3>
          <div className='info-item'>
            <label className='info-label'>Email</label>
            <div className='info-value'>{clinicDataToView?.email}</div>
          </div>
          <div className='info-item'>
            <label className='info-label'>Contact No.</label>
            <div className='info-value'>{clinicDataToView?.phone}</div>
          </div>
        </div>
    </Modal>
  );
};

export default ClinicModalView;
